/**
 * 主应用组件
 * 路由配置 + Ant Design 主题
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import AppLayout from './layouts/AppLayout';
import NewTaskPage from './pages/NewTaskPage';
import HistoryPage from './pages/HistoryPage';
import TemplatesPage from './pages/TemplatesPage';
import './App.css';

const theme = {
  token: {
    colorPrimary: '#764ba2',
    borderRadius: 8,
  },
};

function App() {
  return (
    <ConfigProvider theme={theme}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/new" replace />} />
          <Route path="/new" element={<NewTaskPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
        </Route>
      </Routes>
    </ConfigProvider>
  );
}

export default App;
